import moment, { Moment } from "moment";
import { Nullable } from "../types/common";

export const DatePickerFormat = "YYYY-MM-DD";
export const DateTimeFormat = "YYYY-MM-DDTH:mm:ss";

export const endOfDay = (dateString: string): string =>
  dateString !== ""
    ? moment(dateString).hour(23).minute(59).seconds(59).format(DateTimeFormat) + "Z"
    : "";

export const formatDate = (
  dateField?: Nullable<string | Moment>,
  format = DatePickerFormat
): string | null =>
  Boolean(dateField) && dateField !== "" ? moment(dateField).format(format) : null;

export const isValidDate = (dateString: string): boolean => moment(dateString).isValid();

export const startOfDay = (dateString: string): string =>
  dateString !== ""
    ? moment(dateString).hour(0).minute(0).seconds(0).format(DateTimeFormat) + "Z"
    : "";

export const toDatePickerValue = (dateTimeString: string): string =>
  formatDate(dateTimeString) || "";

export const dateIsBeforeToday = (dateString: string): boolean =>
  moment().diff(dateString, "days") > 0;
